// extracted by mini-css-extract-plugin
export default {"container":"Accelerometer_container__CzDa8","content":"Accelerometer_content__brLsL"};